import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { ListStatus, ListUserRoles } from "@/constants/default";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { useForm } from "react-hook-form";
import { useEditUserMutation, useGetUserQuery } from "@/services/user.service";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import Information, { UserFieldForm } from "./_information";

export default function EditUser() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const { auth } = useSelector((state: RootState) => state.auth)
    const listStatus = ListStatus();
    const listRoles = ListUserRoles().filter(item => item.value > auth.role)
    const [editUser, {isSuccess}] = useEditUserMutation()
    const {data: user} = useGetUserQuery(location.state?.id || "", {refetchOnMountOrArgChange: true})
    const {register, handleSubmit, formState: {errors}, control, watch, setValue} = useForm<UserFieldForm>()

    const onSubmit = handleSubmit(async (data) => {
        if(user) {
            editUser({...data, ...{email: user.email}, id: user?.id,})
        }
    })

    useEffect(() => {
        if (user) {
            setValue("status", _.find(listStatus, item => item.value === Boolean(user.status))?.value || listStatus[1].value)
            setValue("role", _.find(listRoles, item => item.value === user.role)?.value || listRoles[0].value)
            setValue("name", user.name)
            setValue("email", user.email)
            setValue("discord_user_id", user.discord_user_id || "")
            setValue("api_only", user.api_only || false)
        }
    }, [user])

    useEffect(() => {
        if(isSuccess) navigate(location, {state: {reload: true}})
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-sm rounded-lg bg-white py-5 px-8 dark:bg-boxdark max-h-[90vh] overflow-y-auto relative">
                <button
                    type="button"
                    onClick={() => navigate(location)}
                    className="absolute top-3 right-3 flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors z-10"
                    aria-label="Close modal"
                >
                    <i className="fa-light fa-times text-xl text-gray-500 dark:text-gray-400"></i>
                </button>
                <h3 className="text-xl dark:text-white text-center font-medium my-5">
                    {t("user.edit_user")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    <Information register={register} control={control} errors={errors} watch={watch} isEdit={true} editingUserRole={user?.role} editingUserId={user?.id} />
                    <div className="flex justify-end">
                        <div className="px-3">
                            <button type="button" onClick={() => navigate(location)} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button type="submit" className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
